import { useContext } from "react";
import SnackBarContext from "./SnackBarContext";

const useSnackBar = () => useContext(SnackBarContext).addSnackBar;

export default useSnackBar;
